//enums
export class VIEWER_MODE {
    // Private Fields
    static #_INITIAL = -1;
    static #_LIST = 0;
    static #_DOC_VIEW = 1;
    static #_FULl_SCREEN = 2;

    // Accessors for "get" functions only (no "set" functions)
    static get INITIAL() {
        return this.#_INITIAL;
    }
    static get LIST() {
        return this.#_LIST;
    }
    static get DOC_VIEW() {
        return this.#_DOC_VIEW;
    }
    static get FULL_SCREEN() {
        return this.#_FULl_SCREEN;
    }
}

export class IMAGE_ORIENTATION {
    // Private fields
    static #_PORTRAIT = 'portrait';
    static #_LANDSCAPE = 'landscape';

    // Accessors for "get" functions only (no "set" functions)
    static get PORTRAIT() {
        return this.#_PORTRAIT;
    }
    static get VERTICAL() {
        return this.#_PORTRAIT;
    }
    static get LANDSCAPE() {
        return this.#_LANDSCAPE;
    }
    static get HORIZONTAL() {
        return this.#_LANDSCAPE;
    }
}

export class PAGE_LOAD_STATUS {
    static #_NOT_LOADED = 'toLoad';
    static #_LOADED = 'loaded';
    static #_READY = 'ready';
    static #_ERROR_SOURCE = 'apiError';
    static #_SECURED = 'secured';
    static #_ERROR_LOAD = 'error';

    static get NOT_LOADED() {
        return this.#_NOT_LOADED;
    }
    static get LOADED() {
        return this.#_LOADED;
    }
    static get READY() {
        return this.#_READY;
    }
    static get ERROR_SOURCE() {
        return this.#_ERROR_SOURCE;
    }
    static get SECURED() {
        return this.#_SECURED;
    }
    static get ERROR_LOAD() {
        return this.#_ERROR_LOAD;
    }
}

export class MANIPULATION {
    // Private Fields
    static #_NONE = -1;
    static #_ACCESSABLE = 0;
    static #_ZOOMABLE = 1;
    static #_PAGINABLE = 2;
    static #_MOVE = 3;
    static #_ROTATE = 4;

    // Accessors for "get" functions only (no "set" functions)
    static get NONE() {
        return this.#_NONE;
    }
    static get ACCESSABLE() {
        return this.#_ACCESSABLE;
    }
    static get ZOOMABLE() {
        return this.#_ACCESSABLE;
    }
    static get PAGINABLE() {
        return this.#_ACCESSABLE;
    }
    static get MOVE() {
        return this.#_MOVE;
    }
    static get ROTATE() {
        return this.#_ROTATE;
    }
}

export class THUMBNAIL_FILTER {
    static #_ALL = 'all';
    static #_BOOKMARKED = 'bookmarked';
    static #_COMMENTED = 'commented';

    static get ALL() {
        return this.#_ALL;
    }
    static get BOOKMARKED() {
        return this.#_BOOKMARKED;
    }
    static get COMMENTED() {
        return this.#_COMMENTED;
    }
}